var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgReportingGradientIcon20 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 7.8H0v27.3C0 37.245 1.71 39 3.8 39h26.6v-3.9H3.8V7.8ZM34.2 0H11.4C9.31 0 7.6 1.755 7.6 3.9v23.4c0 2.145 1.71 3.9 3.8 3.9h22.8c2.09 0 3.8-1.755 3.8-3.9V3.9C38 1.755 36.29 0 34.2 0Zm-1.9 17.55h-19v-3.9h19v3.9Zm-7.6 7.8H13.3v-3.9h11.4v3.9Zm7.6-15.6h-19v-3.9h19v3.9Z",
    fill: "#4B4C6A"
  })));
};
export { SvgReportingGradientIcon20 as ReactComponent };
export default __webpack_public_path__ + "653526ff56139c13cf5564bee42bffd1.svg";